import { NumberOfConvertedVehiclesReportData } from '../../../../../types/NumberOfConvertedVehiclesReportTypes';

export const initNumberOfConvertedVehiclesData: NumberOfConvertedVehiclesReportData = {
  items: [],
  minConvertedVehicles: 0,
  maxConvertedVehicles: 0,
};
